import script from "./InitialHierarchySetup.vue?vue&type=script&setup=true&lang=js"
export * from "./InitialHierarchySetup.vue?vue&type=script&setup=true&lang=js"

import "./InitialHierarchySetup.vue?vue&type=style&index=0&id=180d77ca&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-180d77ca"]])

export default __exports__